import { theme } from "../../../App";
const styles = () => ({
  selectMenu: {
    whiteSpace: "normal",
  },

  menuItem: {
    whiteSpace: "normal",
    height: "auto",
  },
  formControl: {
    padding: "0 0 40px 0",
    display: "flex",
    flexDirection: "row",
    maxWidth: 780,
    overflow: "auto",
  },
  label: {
    paddingLeft: 10,
    lineHeight: "36px",
    fontSize: 18,
    [theme.breakpoints.down("lg")]: {
      fontSize: 14,
    },
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 24,
  },
  endPointsContainer: {
    display: "flex",
    margin: "20px 0px",
  },
  endPoints: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    height: "inherit",
    paddingRight: 16,
    [theme.breakpoints.down("lg")]: {
      paddingRight: 8,
      fontSize: 12,
    },
  },
  endPonitIndicatorContainer: {
    height: "inherit",
    width: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  endPonitIndicatorHorizontal: {
    width: "100%",
    border: "solid 1px #dadce0",
  },
  endPonitIndicatorVerticale: {
    height: "calc(100% - 32px)",
    border: "solid 1px #dadce0",
    width: "0px",
  },
  endPointsHigh: {
    marginTop: "-10px",
  },
  endPointsLow: {
    marginBottom: "20px",
  },
  offscreenText: {
    opacity: 0,
    position: "absolute",
  },
});

export default styles;
